import React, { useEffect, useRef, useState } from "react";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import {
  getProgramReportData,
  getSahaySubTypeList,
  getSahayTypeList,
  getSubSahayReportData,
} from "../../../../redux/features/AddService";
import { useSelector } from "react-redux";
import PageLoading from "../../../../components/common/pageLoading/PageLoading";
// import SahayMultiPleTableList from "./SahayMultiPleTableList";
import { useReactToPrint } from "react-to-print";
import { Autocomplete } from "@mui/material";
import PrintReport from "../../../../components/common/printReport/PrintReport";
import FileExcel from "../../../../components/common/excelSheet/FileExcel";
import RowPerPageDropdown from "../../../../components/common/paginationRowPerpage/RowPerPageDropdown";
import Pagination from "../../../../components/common/Pagination";
import { Api } from "../../../../config/Api";
import dataService from "../../../../config/DataService";
import moment from "moment";
import dayjs from "dayjs";

const familyIncomeAmountList = [
  { id: 1, ammount: "Less than 5 lakh" },
  { id: 2, ammount: "5 lakh or above" },
];

const electricBillAmountList = [
  { id: 1, ammount: "0 to 1000" },
  { id: 2, ammount: "1001 to 2500" },
  { id: 3, ammount: "2501 to 3500" },
  { id: 4, ammount: "3501 and Above" },
];

export default function ProgramReport() {
  const navigate = PagesIndex.useNavigate();
  const dispatch = PagesIndex.useDispatch();
  const location = PagesIndex.useLocation();
  const { getSubSahayReportDataList } = PagesIndex.useSelector(
    (state) => state?.admin
  );

  const rollData = JSON.parse(localStorage?.getItem("RollName"))?.toLowerCase();
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [excel, setExcel] = useState([]);
  const [filterSubSahayName, setFilterSubSahayName] = useState("");
  const [filter, setFilter] = useState("");
  const [filterSubSahay, setFilterSubSahay] = useState("");
  const [filterSahay, setFilterSahay] = useState("");
  const [filterYear, setFilterYear] = useState("");
  const [searchedData, setSearchedData] = useState([]);
  const [sahayTypeList, setSahayTypeList] = useState([]);
  const [sahaySubTypeList, setSahaySubTypeList] = useState([]);
  const [pageData, setPageData] = useState([]);
  const [rowPerPage, setRowPerPage] = useState("25");
  const [filterReportData, setFilterReportData] = useState([]);
  const [filterFamilyIncome, setFilterFamilyIncome] = useState("");
  const [filterElectricityBill, setFilterElectricityBill] = useState("");
  const [filterProgramName, setFilterProgramName] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Print Reports
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  // //Filter Data

  useEffect(() => {
    const filters = {
      FID: filter,
      Year: filterYear,
      SahayName: filterSahay,
      SubSahayName: filterSubSahay,
      familyIncome: filterFamilyIncome,
      electricityBill: filterElectricityBill,
      ProgramName: filterProgramName,
      // StartDate: startDate,
      // endDate: endDate,
    };

    const filterData = data?.filter((ele) => {
      if (Object.values(filters).some(Boolean)) {
        return Object.entries(filters).every(([key, value]) => {
          if (!value) return true;
          return ele[key] == value;
        });
      } else {
        return true;
      }
    });
    setFilterReportData(filterData);
  }, [
    filter,
    filterYear,
    filterSahay,
    filterSubSahay,
    filterElectricityBill,
    filterFamilyIncome,
    filterProgramName,
  ]);

  useEffect(() => {
    if (startDate && endDate) {
      const filtered = data.filter((item) => {
        return item.StartDate >= startDate && item.StartDate <= endDate;
      });
      setFilterReportData(filtered);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    setSearchedData(filterReportData);
  }, [filterReportData]);

  const fileName = "Sahay Detail Sahay Wise CSV";
  useEffect(() => {
    const customHeadings = filterReportData?.map((item) => ({
      Fid: item?.FID,
      "Applicant name": item?.ApplicantName,
      "Sahay Name": item?.SahayName,
      "Sub Sahay Name": item?.SubSahayName,
      "Beneficiary Name": item?.BeneficiaryName,
      "Moholla Name": item?.MohollaName,
      Area: item?.Area,
      "Requested Sahay": item?.SahayAmount,
      "Approve Amount": item?.ApproveAmount,
      Year: item?.Year,
      "Application Date Received": item?.applicationReceiveDate,
      "Application Entered Date": item?.ApplicationEnteredDate,
      "Committee Approval Date": item?.committeeApprovalDate,
      "Filing Date": item?.formFillingDate,
      "Electricity Bill": item?.electricityBill,
      "Family Income": item?.familyIncome,
    }));

    setExcel(customHeadings);
  }, [filterReportData]);

  const requestSearch = (searched) => {
    if (!searched) return setSearchedData(filterReportData);

    setSearchedData(
      filterReportData?.filter(
        (item) =>
          item?.ProgramName?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase()) ||
          item?.VendorName?.toString()
            ?.toLowerCase()
            .includes(searched?.toLowerCase())
      )
    );
  };

  //get Sub sahay list
  // const getSahaySubTypeData = async (id) => {
  //   dispatch(getSahaySubTypeList(id)).then((res) => {
  //     if (res?.payload) {
  //       setSahaySubTypeList(res?.payload);
  //     } else {
  //       setSahaySubTypeList([]);
  //     }
  //   });
  // };
  // //Sahay Type list
  // const fetchSahayTypeList = () => {
  //   dispatch(getSahayTypeList()).then((res) => {
  //     setSahayTypeList(res?.payload);
  //   });
  // };

  // useEffect(() => {
  //   fetchSahayTypeList();
  //   getSahaySubTypeData();
  // }, []);

  useEffect(() => {
    dispatch(getProgramReportData()).then((res) => {
      if (res?.payload?.status == 200) {
        setData(res?.payload?.data);
        setLoader(false);
      }
      setLoader(false);
    });
  }, []);

  //#region start view sahay application

  // const handleSahayApplicationView = (viewdata) => {
  //   const updatedViewData = {
  //     ...viewdata,
  //     familyId: viewdata?.FID,
  //     prevRoute: location?.pathname,
  //   };
  //   navigate(`/${rollData}/sahay-report-view`, { state: updatedViewData });
  // };

  //#region end view sahay application

  const { rollPermissionData } = useSelector((state) => state.admin);
  const rollPermissionNameData =
    rollPermissionData?.findData?.parentRoleName?.toLowerCase();

  const handleMemberView = (data) => {
    navigate("/admin/program-report-member-view", { state: data?.MemberList });
  };

  if (
    rollPermissionData?.permissionArray?.includes("Program Report_view") ||
    rollPermissionNameData === "admin"
  ) {
  } else {
    navigate(`/${rollData}/sahay-application`);
  }
  return (
    <>
      {loader ? (
        <PageLoading />
      ) : (
        <>
          <Index.Box className="page-content-box">
            <Index.Box className="barge-common-box">
              <Index.Box className="title-header">
                <Index.Box className="title-header-flex res-title-header-flex">
                  <Index.Box className="plus-hidden-show-mobile">
                    <Index.Box className="title-main">
                      <Index.Typography
                        variant="p"
                        component="p"
                        className="page-title"
                      >
                        Program Report
                      </Index.Typography>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="table-list">
                <Index.Box className="grid-row sahay-multiple-main">
                  <Index.Box sx={{ width: 1 }} className="grid-main">
                    <Index.Box
                      display="grid"
                      className="multiple-row"
                      gridTemplateColumns="repeat(12, 1fr)"
                      gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                    >
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 4",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <PagesIndex.Search
                            className="search sahay-multiple-search"
                            onChange={(e) => requestSearch(e.target.value)}
                          >
                            <PagesIndex.StyledInputBase placeholder="Search" />
                          </PagesIndex.Search>
                        </Index.Box>
                      </Index.Box>

                      {/* Program name */}
                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 4",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            className="multiple-autocomplet-control"
                            id="combo-box-demo"
                            options={data || []}
                            getOptionLabel={(option) =>
                              option?.ProgramName?.toString()
                            }
                            onChange={(value, newvalue) => {
                              setFilterProgramName(newvalue?.ProgramName);
                            }}
                            filterOptions={(options, { inputValue }) => {
                              const inputLowerCase = inputValue?.toLowerCase();
                              const uniqueProgramName = new Set();
                              return options?.filter((option) => {
                                const programName =
                                  option?.ProgramName?.toString()?.toLowerCase();
                                // Check unique
                                if (uniqueProgramName?.has(programName)) {
                                  return false;
                                }
                                // Check search
                                if (programName?.includes(inputLowerCase)) {
                                  uniqueProgramName?.add(programName);
                                  return true;
                                }
                                return false;
                              });
                            }}
                            renderInput={(params) => (
                              <Index.TextField {...params} label="Program" />
                            )}
                          />
                        </Index.Box>
                      </Index.Box>

                      {/* Sahay category */}
                      {/* <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className="multiple-autocomplet-control"
                            options={sahayTypeList || []}
                            getOptionLabel={(option) => option?.Sahay_category}
                            onChange={(value, newvalue) => {
                              setSahaySubTypeList([]);
                              setFilterSubSahay("");
                              // setFilter("");
                              setFilterSahay(newvalue?.Sahay_category);
                              getSahaySubTypeData(newvalue?.Id);
                            }}
                            renderInput={(params) => (
                              <Index.TextField {...params} label="Sahay Name" />
                            )}
                          />
                        </Index.Box>
                      </Index.Box> */}

                      {/* SahayName */}
                      {/* <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className="multiple-autocomplet-control"
                            options={sahaySubTypeList}
                            getOptionLabel={(option) => option?.SahayName}
                            onChange={(value, newvalue) => {
                              setFilterSubSahay(newvalue?.SahayName);
                            }}
                            value={
                              sahaySubTypeList &&
                              sahaySubTypeList.length > 0 &&
                              filterSubSahay
                                ? sahaySubTypeList.find(
                                    (item) => item.SahayName === filterSubSahay
                                  )
                                : null
                            }
                            renderInput={(params) => (
                              <Index.TextField
                                {...params}
                                label="Sub Sahay Name"
                              />
                            )}
                          />
                        </Index.Box>
                      </Index.Box> */}

                      {/* familyIncomeAmountList */}
                      {/* <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className="multiple-autocomplet-control"
                            options={familyIncomeAmountList || []}
                            getOptionLabel={(option) => option?.ammount}
                            onChange={(value, newvalue) => {
                              setFilterFamilyIncome(newvalue?.ammount);
                            }}
                            renderInput={(params) => (
                              <Index.TextField
                                {...params}
                                label="Family Income"
                              />
                            )}
                          />
                        </Index.Box>
                      </Index.Box> */}

                      {/* Electric Bill AmountList */}
                      {/* <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className="multiple-autocomplet-control"
                            options={electricBillAmountList || []}
                            getOptionLabel={(option) => option?.ammount}
                            onChange={(value, newvalue) => {
                              setFilterElectricityBill(newvalue?.ammount);
                            }}
                            renderInput={(params) => (
                              <Index.TextField
                                {...params}
                                label="Electricity Bill"
                              />
                            )}
                          />
                        </Index.Box>
                      </Index.Box> */}

                      {/* Year */}
                      {/* <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column"
                      >
                        <Index.Box className="sahay-multiple-input-main">
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            className="multiple-autocomplet-control"
                            options={data || []}
                            getOptionLabel={(option) => option?.Year}
               
                            onChange={(value, newvalue) => {
                              setFilterYear(newvalue?.Year);
                            }}
                            filterOptions={(options, { inputValue }) => {
                              const inputLowerCase = inputValue?.toLowerCase();
                              const uniqueYear = new Set();
                              return options?.filter((option) => {
                                const Year =
                                  option?.Year?.toString()?.toLowerCase();
                                // Check unique
                                if (uniqueYear?.has(Year)) {
                                  return false;
                                }
                                // Check search
                                if (Year?.includes(inputLowerCase)) {
                                  uniqueYear?.add(Year);
                                  return true;
                                }
                                return false;
                              });
                            }}
                            renderInput={(params) => (
                              <Index.TextField {...params} label="Year" />
                            )}
                          />
                        </Index.Box>
                      </Index.Box> */}

                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column common-date-picker-column"
                      >
                        <Index.Box className="sahay-multiple-input-main common-date-picker-custom date-input-box">
                          <Index.LocalizationProvider
                            dateAdapter={Index.AdapterDayjs}
                            sx={{ position: "absolute" }}
                          >
                            <Index.DemoContainer components={["DatePicker"]}>
                              <Index.DatePicker
                                name="startDate"
                                value={startDate}
                                onChange={(value) => {
                                  setStartDate(
                                    moment(value.$d).format("YYYY-MM-DD")
                                  );
                                }}
                                format="YYYY-MM-DD"
                                sx={{
                                  bottom: "4px",
                                  width: "100%",
                                }}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                              />
                            </Index.DemoContainer>
                          </Index.LocalizationProvider>
                        </Index.Box>
                      </Index.Box>

                      <Index.Box
                        gridColumn={{
                          xs: "span 12",
                          sm: "span 6",
                          md: "span 3",
                          lg: "span 3",
                        }}
                        className="grid-column common-date-picker-column"
                      >
                        <Index.Box className="sahay-multiple-input-main common-date-picker-custom date-input-box">
                          <Index.LocalizationProvider
                            dateAdapter={Index.AdapterDayjs}
                            sx={{ position: "absolute" }}
                          >
                            <Index.DemoContainer components={["DatePicker"]}>
                              <Index.DatePicker
                                name="toDate"
                                value={endDate}
                                onChange={(value) => {
                                  setEndDate(
                                    moment(value.$d).format("YYYY-MM-DD")
                                  );
                                }}
                                format="YYYY-MM-DD"
                                sx={{
                                  bottom: "4px",
                                  width: "100%",
                                }}
                                slotProps={{
                                  textField: {
                                    size: "small",
                                    error: false,
                                  },
                                }}
                              />
                            </Index.DemoContainer>
                          </Index.LocalizationProvider>
                        </Index.Box>
                      </Index.Box>

                      {filterReportData?.length > 0 &&
                        searchedData?.length > 0 && (
                          <>
                            <Index.Box
                              gridColumn={{
                                xs: "span 12",
                                sm: "span 6",
                                md: "span 4",
                                lg: "span 3",
                              }}
                              className="grid-column"
                            >
                              <Index.Box className="auth-input-main sahay-multiple-input-main">
                                <Index.Box
                                  Box
                                  className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                                >
                                  <FileExcel
                                    apiData={excel}
                                    fileName={fileName}
                                  />
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                            <Index.Box
                              gridColumn={{
                                xs: "span 12",
                                sm: "span 6",
                                md: "span 4",
                                lg: "span 3",
                              }}
                              className="grid-column"
                            >
                              <Index.Box className="sahay-multiple-input-main">
                                <Index.Box
                                  Box
                                  className="res-auto-left common-button blue-button multiple-download-btn res-blue-button"
                                >
                                  <Index.Button onClick={handlePrint}>
                                    Print
                                  </Index.Button>
                                </Index.Box>
                              </Index.Box>
                            </Index.Box>
                          </>
                        )}
                    </Index.Box>
                  </Index.Box>
                </Index.Box>

                <Index.TableContainer
                  sx={{ maxHeight: 180 }}
                  component={Index.Paper}
                  className="table-container user-master-container scroll-table"
                >
                  <Index.Table
                    stickyHeader
                    aria-label="sticky table"
                    className="table-design-main barge-table multiple-tablelist-table"
                  >
                    <Index.TableHead className="user-master-head">
                      <Index.TableRow className="user-master-tr">
                        <Index.TableCell className="user-master-th">
                          S.No.
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Program Name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Vendor Name
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Bill Number
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Bill Date
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          Start Date
                        </Index.TableCell>
                        <Index.TableCell className="user-master-th">
                          End Date
                        </Index.TableCell>

                        <Index.TableCell className="user-master-th">
                          Total Amount
                        </Index.TableCell>

                        <Index.TableCell className="user-master-th">
                          Member List
                        </Index.TableCell>
                      </Index.TableRow>
                    </Index.TableHead>
                    <Index.TableBody className="user-master-tbody">

                      {pageData?.length &&
                      (filter ||
                        filterYear ||
                        filterSahay ||
                        filterSubSahay ||
                        filterElectricityBill ||
                        filterFamilyIncome ||
                        startDate ||
                        filterProgramName) ? (
                        pageData?.map((data, index) => {
                          return (
                            <Index.TableRow
                              className="user-master-tr"
                              key={index}
                              // onClick={() => handleSahayApplicationView(data)}
                              sx={{ cursor: "pointer" }}
                            >
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-role-name">
                                  {index + 1 || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-details-name">
                                  {data?.ProgramName || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-details-name">
                                  {data?.VendorName || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-details-name">
                                  {data?.BillNumber || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-email-name">
                                  {moment(data?.BillDate).format(
                                    "YYYY-MM-DD"
                                  ) || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.StartDate || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.EndDate || "-"}
                                </Index.Box>
                              </Index.TableCell>
                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {data?.TotalAmount || "-"}
                                </Index.Box>
                              </Index.TableCell>

                              <Index.TableCell className="user-master-td">
                                <Index.Box className="user-number-name">
                                  {/* {rollPermissionData?.permissionArray?.includes(
                                    "User Master_view"
                                    ) || rollPermissionNameData === "admin" ? ( */}
                                  <>
                                    <Index.IconButton
                                      onClick={() => handleMemberView(data)}
                                    >
                                      <Index.Visibility className="muiico-view" />
                                    </Index.IconButton>
                                  </>
                                  {/* ) : (
                                    ""
                                    )} */}
                                </Index.Box>
                              </Index.TableCell>
                            </Index.TableRow>
                          );
                        })
                      ) : (
                        <PagesIndex.NoRecordFound colSpan={16} />
                      )}
                    </Index.TableBody>
                  </Index.Table>
                </Index.TableContainer>
                {filterReportData?.length > 0 && searchedData?.length > 0 && (
                  <Index.Box className="multiple-total-text-main">
                    <Index.Typography className="multiple-total-text">
                      Total Amount :
                      {searchedData.length > 0 &&
                        searchedData?.reduce((acc, curr) => {
                          let total;
                          total = acc + curr?.TotalAmount;
                          return total;
                        }, 0)}
                    </Index.Typography>
                  </Index.Box>
                )}

                <Index.Box className="pagination-design flex-end">
                  <RowPerPageDropdown
                    rowPerPage={rowPerPage}
                    setRowPerPage={setRowPerPage}
                  />
                  <Index.Stack spacing={2}>
                    <Pagination
                      fetchData={searchedData}
                      setPageData={setPageData}
                      pageData={pageData}
                      rowPerPage={rowPerPage}
                    />
                  </Index.Stack>
                </Index.Box>

                <Index.Box sx={{ display: "none" }}>
                  <PrintReport
                    componentRef={componentRef}
                    tableData={excel}
                    reportName={[{ type: "SahayWiseReport" }]}
                  />
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </>
      )}
    </>
  );
}
